import { render, staticRenderFns } from "./ImageHeader.vue?vue&type=template&id=72727b67&scoped=true"
import script from "./ImageHeader.vue?vue&type=script&lang=js"
export * from "./ImageHeader.vue?vue&type=script&lang=js"
import style0 from "./ImageHeader.vue?vue&type=style&index=0&id=72727b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72727b67",
  null
  
)

export default component.exports